import React, { useEffect, useState, lazy, memo } from 'react';
import { Button } from './Button';
import { PriceDisplay } from './PriceDisplay';
import { Star, Zap, Gift } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center gap-2 mt-2" data-id="element-89">
      <div className="bg-dark text-white font-heading font-bold text-2xl rounded-lg px-3 py-2 min-w-[52px] text-center" data-id="element-90">
        {String(minutes).padStart(2, '0')}
      </div>
      <span className="text-dark font-bold text-2xl" data-id="element-91">:</span>
      <div className="bg-dark text-white font-heading font-bold text-2xl rounded-lg px-3 py-2 min-w-[52px] text-center" data-id="element-92">
        {String(seconds).padStart(2, '0')}
      </div>
    </div>;
}
function GuaranteeAccordion() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="w-full mt-3 rounded-xl border border-green-200 bg-green-50/50 overflow-hidden" data-id="element-93">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-4 py-3 text-left" data-id="element-94">
        <span className="text-sm font-semibold text-green-700 flex items-center gap-2" data-id="element-95">
          🛡️ Garantía de satisfacción de 7 días
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="text-green-600 text-lg" data-id="element-96">
          ▾
        </motion.span>
      </button>
      <AnimatePresence data-id="element-97">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-98">
            <div className="px-4 pb-4 text-xs text-gray-600 leading-relaxed space-y-2" data-id="element-99">
              <p data-id="element-100">
                Con el Mega Kit Imprimible de Fiestas + 6 Bonos de Regalo tenés{' '}
                <strong data-id="element-101">7 días de prueba real.</strong>
              </p>
              <p data-id="element-102">Si en los primeros 7 días sentís que el kit no te da:</p>
              <ul className="list-disc pl-4 space-y-1" data-id="element-103">
                <li data-id="element-104">Diseños listos para imprimir sin complicaciones</li>
                <li data-id="element-105">
                  Plantillas que se editan en minutos aunque no sepas de diseño
                </li>
                <li data-id="element-106">
                  Variedad suficiente para armar fiestas completas y originales
                </li>
                <li data-id="element-107">Recursos para empezar tu propio negocio de decoración</li>
                <li data-id="element-108">La seguridad de cobrar bien tu trabajo creativo</li>
              </ul>
              <p className="font-semibold text-dark" data-id="element-109">
                👉 Te devolvemos el 100% de tu dinero. Sin excusas, sin
                condiciones, sin explicaciones.
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Hero() {
  const carouselImages = ['https://cdn.magicpatterns.com/uploads/mJjLsPTL5biXghLYa1fMHa/IMG_8628.jpg', 'https://cdn.magicpatterns.com/uploads/3iQg9NMTqodYiQFMfUHh2Z/IMG_8630.jpg', 'https://cdn.magicpatterns.com/uploads/vKjf8k5kjerSjMwpLNiQ3V/IMG_8631.jpg', 'https://cdn.magicpatterns.com/uploads/2JVVvEDiL2NCWHRhwi9yLf/IMG_8486.jpg', 'https://cdn.magicpatterns.com/uploads/bLrKkDYJNDrV5sKyzvcwv3/IMG_8624.jpg'];
  return <section className="relative pt-6 pb-6 px-4 bg-transparent overflow-hidden w-full" data-id="element-110">
      <div className="max-w-6xl mx-auto w-full" data-id="element-111">
        <div className="flex flex-col items-center w-full" data-id="element-112">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center space-y-5 z-10 flex flex-col items-center" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/rkR6HekELkRZNvvjTjx1ZN/IMG_8554.png" alt="Armá tu fiesta completa en menos de 1 hora con plantillas listas para imprimir" className="w-full max-w-md mx-auto rounded-2xl" fetchPriority="high" width={448} height={448} data-id="element-114" />

            <p className="text-base md:text-lg text-body/90 font-normal leading-[1.8] max-w-lg mx-auto" data-id="element-115">
              Más de{' '}
              <strong className="text-dark font-semibold" data-id="element-116">
                +10.000 diseños
              </strong>
              , plantillas y recursos para crear fiestas mágicas y
              profesionales, aunque nunca hayas decorado en tu vida.
            </p>

            {/* CAROUSEL — CSS animation instead of Framer Motion */}
            <div className="w-full max-w-md mx-auto rounded-2xl" style={{
            overflow: 'hidden',
            position: 'relative',
            height: '144px'
          }} data-id="element-117">
              <div className="flex gap-3 animate-carousel absolute top-0 left-0" style={{
              height: '144px'
            }} data-id="element-118">
                {[...Array(2)].flatMap((_, setIdx) => carouselImages.map((src, imgIdx) => <img key={`${setIdx}-${imgIdx}`} src={src} alt={`Ejemplo de fiesta ${imgIdx + 1}`} className="w-36 h-36 object-cover rounded-xl flex-shrink-0 shadow-card" width={144} height={144} data-id="element-119" />))}
              </div>
            </div>

            <img src="https://cdn.magicpatterns.com/uploads/pE8DQTyuVg5PS2BPbMf3mD/20260409_1056_Image_Generation_simple_compose_01kns8e7h2fv88n2a4qw0bc48b.png" alt="Organizar una fiesta hermosa no debería ser tan complicado, tan caro ni tan estresante" className="w-full max-w-md mx-auto rounded-2xl" loading="lazy" width={448} height={448} data-id="element-120" />

            {/* Pain Points */}
            <div className="w-full max-w-md mx-auto space-y-3 text-left" data-id="element-121">
              <h3 className="text-2xl font-heading font-semibold text-dark text-center mb-2" data-id="element-122">
                ¿Alguna vez te pasó esto?
              </h3>
              {[{
              emoji: '🎨',
              title: 'Cero experiencia en diseño',
              desc: 'No sabés por dónde empezar.'
            }, {
              emoji: '⏰',
              title: 'El tiempo no te alcanza',
              desc: 'El cumple está encima.'
            }, {
              emoji: '💸',
              title: 'Presupuestos altísimos',
              desc: 'Te cobraron una fortuna.'
            }, {
              emoji: '😩',
              title: 'Horas buscando diseños',
              desc: 'Y no lográs hacer nada.'
            }].map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.8 + i * 0.1,
              duration: 0.4
            }} className="flex items-center gap-3 bg-white/70 backdrop-blur-sm rounded-xl px-4 py-3 shadow-sm border border-white/80" data-id="element-123">
                  <span className="text-xl flex-shrink-0" data-id="element-124">{point.emoji}</span>
                  <p className="text-sm text-dark leading-snug" data-id="element-125">
                    <strong data-id="element-126">{point.title}</strong> —{' '}
                    <span className="text-body/70" data-id="element-127">{point.desc}</span>
                  </p>
                </motion.div>)}

              <p className="text-2xl md:text-3xl font-heading font-bold text-primary text-center pt-2" data-id="element-128">
                ¡No te estreses más!
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/dvG22PkKJxEfUCWAAobdqR/20260409_1046_Image_Generation_simple_compose_01kns7shjbf4a871n3gqpg1nwx_(1).png" alt="El Pack Soñado para Fiestas - 10 Veces Mejor" className="w-full rounded-2xl shadow-card" loading="lazy" width={448} height={448} data-id="element-129" />
            </div>

            {/* Steps + Image */}
            <div className="w-full max-w-md mx-auto text-center space-y-3" data-id="element-130">
              <img src="https://cdn.magicpatterns.com/uploads/ciQesabHfTiSG2g9LmXVMC/Plantillas_listas_para_imprimir,_100_editables._Sin_ser_disenadora._Sin_rogarle_a_nadie._Sin_gastar_una_fortuna._(1).png" alt="Ejemplos de plantillas de fiestas impresas" className="w-full rounded-2xl shadow-card" loading="lazy" width={448} height={448} data-id="element-131" />
              <p className="text-lg md:text-xl font-heading font-semibold text-dark leading-snug" data-id="element-132">
                Descargá, Personalizá, Imprimí y Recortá!
              </p>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary" data-id="element-133">
                🎉 TU DECO ESTÁ LISTA 🎉
              </p>
            </div>

            {/* Features inline */}
            <div className="w-full max-w-md mx-auto space-y-3 text-left" data-id="element-134">
              <p className="text-sm font-semibold text-primary uppercase tracking-wider text-center" data-id="element-135">
                Mega Pack Fiesta Lista
              </p>
              <h3 className="text-2xl font-heading font-semibold text-dark text-center mb-2" data-id="element-136">
                La Colección Más Completa de Plantillas
              </h3>
              <p className="text-sm text-body/90 leading-[1.8] text-center mb-1" data-id="element-137">
                Armá tu fiesta completa en menos de 1 hora — aunque nunca hayas
                hecho una decoración en tu vida.
              </p>
              {[{
              emoji: '⚡',
              title: 'Plantillas Listas en Tiempo Récord',
              desc: 'Abrís el archivo, cambiás el nombre y ya está.'
            }, {
              emoji: '✨',
              title: 'Diseños Dignos de Pinterest',
              desc: 'Estética profesional, sin ser diseñadora.'
            }, {
              emoji: '💰',
              title: 'Ahorrás una Fortuna',
              desc: 'Resultado premium por una fracción del precio.'
            }, {
              emoji: '🙌',
              title: 'Apto para Todas',
              desc: 'Instrucciones paso a paso, sin experiencia previa.'
            }, {
              emoji: '🚀',
              title: 'Iniciá tu Propio Negocio',
              desc: 'Incluye guía para arrancar tu emprendimiento.'
            }].map((feature, i) => <motion.div key={`feat-${i}`} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.2 + i * 0.08,
              duration: 0.4
            }} className="flex items-center gap-3 bg-white/70 backdrop-blur-sm rounded-xl px-4 py-3 shadow-sm border border-white/80" data-id="element-138">
                  <span className="text-xl flex-shrink-0" data-id="element-139">{feature.emoji}</span>
                  <p className="text-sm text-dark leading-snug" data-id="element-140">
                    <strong data-id="element-141">{feature.title}</strong> —{' '}
                    <span className="text-body/70" data-id="element-142">{feature.desc}</span>
                  </p>
                </motion.div>)}
            </div>

            <div className="w-full max-w-md mx-auto text-center" data-id="element-143">
              <span className="inline-block bg-green-500 text-white font-extrabold text-sm md:text-base px-5 py-2 rounded-full tracking-wider uppercase shadow-sm" data-id="element-144">
                🏆 Número 1 en Ventas
              </span>
            </div>

            <div className="flex flex-col items-center gap-4 w-full" data-id="element-145">
              <div className="bg-surface rounded-2xl p-6 md:p-8 border border-gray-100 shadow-[0_0_60px_rgba(255,45,138,0.08)] w-full max-w-md" data-id="element-146">
                <p className="text-xs font-semibold text-dark text-left mb-3" data-id="element-147">
                  +1800 DESCARGAS
                </p>
                <p className="text-base font-heading font-semibold text-dark text-center mb-4" data-id="element-148">
                  MEGA PACK FIESTA LISTA + 6 BONUS DE REGALO
                </p>
                <div className="flex flex-col items-center gap-1 mb-3" data-id="element-149">
                  <span className="text-gray-400 line-through text-lg font-medium" data-id="element-150">
                    $70.000
                  </span>
                  <div className="text-5xl md:text-6xl font-heading font-bold text-primary leading-none tracking-[-0.02em]" data-id="element-151">
                    $19.920 <span className="text-lg font-medium" data-id="element-152">ARS</span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 font-medium text-center mb-4" data-id="element-153">
                  OFERTA DESCUENTO · SOLO 20 CUPOS
                </p>
                <motion.div animate={{
                opacity: [1, 0.6, 1]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="bg-red-500 text-white text-xs font-bold text-center py-2 px-4 rounded-full mx-auto w-fit mb-4" data-id="element-154">
                  🔥 ÚLTIMOS CUPOS
                </motion.div>
              </div>
              <div className="w-full max-w-md" data-id="element-155">
                <Button fullWidth className="text-xl py-6" data-id="element-156">
                  Quiero mi fiesta Lista!
                </Button>
              </div>
              <div className="w-full max-w-md text-center space-y-2 mt-2" data-id="element-157">
                <p className="text-sm font-semibold text-dark" data-id="element-158">
                  ⚡ Oferta solo por hoy
                </p>
                <p className="text-xs text-gray-500" data-id="element-159">
                  Reserva válida 15 minutos. Si no accedés, el descuento pasa a
                  la siguiente persona.
                </p>
                <CountdownTimer data-id="element-160" />
                <img src="https://cdn.magicpatterns.com/uploads/7KCbNFNPrvwGcusmbz7X8X/IMG_8740.jpg" alt="Pago seguro garantizado - MercadoLíder Platinum" className="w-full max-w-sm mx-auto rounded-xl mt-2" loading="lazy" width={384} height={200} data-id="element-161" />
                <GuaranteeAccordion data-id="element-162" />
              </div>

              {/* Bonuses */}
              <div className="w-full max-w-md text-center mt-2" data-id="element-163">
                <p className="text-2xl font-heading font-bold text-dark mb-1" data-id="element-164">
                  🎁 SOLO POR HOY 🎁
                </p>
                <p className="text-2xl font-heading font-bold text-primary mb-4" data-id="element-165">
                  ¡LLEVATE 6 BONUS GRATIS!
                </p>
                <div className="space-y-4 text-left" data-id="element-166">
                  {[{
                  emoji: '🏷️',
                  title: '+600 Etiquetas Escolares',
                  desc: 'Personalizá útiles y cuadernos en minutos.',
                  img: 'https://cdn.magicpatterns.com/uploads/v5kPAoiJh7m2N9J9jrfiDv/IMG_8822.jpg'
                }, {
                  emoji: '📖',
                  title: '+200 Libritos para Colorear',
                  desc: 'Perfectos para souvenirs y actividades.',
                  img: 'https://cdn.magicpatterns.com/uploads/u2jfrBgNRyfBDcSrC9bi9t/IMG_8628_2.jpg',
                  imgPosition: 'object-bottom'
                }, {
                  emoji: '💌',
                  title: '+250 Invitaciones Digitales',
                  desc: 'Modernas, listas para enviar por WhatsApp.',
                  img: 'https://cdn.magicpatterns.com/uploads/mufrRGAcfv21na4KprYhC9/IMG_8824.jpg'
                }, {
                  emoji: '📦',
                  title: '+120 Plantillas de Packaging',
                  desc: 'Cajitas y bolsitas temáticas para souvenirs.',
                  img: 'https://cdn.magicpatterns.com/uploads/3yAyHJedxKQvq1SE3EfuqM/IMG_8828.jpg'
                }, {
                  emoji: '🌸',
                  title: '10 Estilos de Flores de Papel',
                  desc: 'Ideales para fondos y mesas dulces.',
                  img: 'https://cdn.magicpatterns.com/uploads/wui8UUKKSq9NCxm3AUXMio/IMG_8829.jpg'
                }, {
                  emoji: '🎂',
                  title: '500 Cakes Toppers',
                  desc: 'Diseños listos para decorar tortas y mesas dulces.',
                  img: 'https://cdn.magicpatterns.com/uploads/hYSmJw5N3mXr6udZiUDL9H/IMG_8833.jpg'
                }].map((bonus, i) => <motion.div key={`bonus-${i}`} initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 1.5 + i * 0.1,
                  duration: 0.4
                }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-167">
                      <img src={bonus.img} alt={bonus.title} className={`w-full h-32 object-cover ${bonus.imgPosition || ''}`} loading="lazy" width={448} height={128} data-id="element-168" />
                      <div className="p-3" data-id="element-169">
                        <p className="text-sm font-semibold text-dark flex items-center gap-2" data-id="element-170">
                          <span className="text-lg" data-id="element-171">{bonus.emoji}</span>{' '}
                          {bonus.title}
                        </p>
                        <p className="text-xs text-body/70 mt-1" data-id="element-172">
                          {bonus.desc}
                        </p>
                        <span className="inline-block mt-2 text-xs font-bold text-primary bg-primary/10 px-3 py-1 rounded-full" data-id="element-173">
                          ✨ HOY GRATIS
                        </span>
                      </div>
                    </motion.div>)}
                </div>

                <img src="https://cdn.magicpatterns.com/uploads/t9q3WJRQE3H2ZpTkDdfp7G/IMG_8853.jpg" alt="3 Cosas que Lograrás con Plantillas - Plantillas listas para imprimir de alta calidad, diseños únicos y profesionales, sorprendé a tu hijo e invitados" className="w-full rounded-2xl shadow-card mt-4" loading="lazy" width={448} height={448} data-id="element-174" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}